export function isUndefined(value: unknown): boolean {
    return typeof value === 'undefined';
}
